import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import alert from '../../assets/images/alert.png';

interface IAlertModal {
  toggleModal: () => void;
  modalIsOpen: boolean;
  title: string;
  body: string;
}

export function AlertModal({
  toggleModal,
  modalIsOpen,
  title,
  body,
}: IAlertModal) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={styles.contents}>
        <div className="d-flex justify-content-center">
          <img className={styles.alert} src={alert} alt="" />
        </div>
        <h1 className={styles.title}>
          <b className={styles.highlightText}>{title}</b> {body}
        </h1>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnAgree}
          type="button"
        >
          OK
        </button>
      </div>
    </Modal>
  );
}
